module.exports = __webpack_public_path__ + "img/2025big21.515e4985.jpg";